import { useEffect, useState } from 'react';
import type { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import * as _ from 'lodash';
import type { IAsync, Project, Revision } from '../../../../types';
import * as ReportGenerationStore from '../../../../redux/reportGeneration';
import type { DependencyInfoOption } from '../shared/types';
import { DefaultDependencyInfoOptions } from './utils';
import { Provider } from './context/ReportContainerContext';

type Props = {
  revision?: IAsync<Revision>;
  project?: IAsync<Project>;
};

const ProjectReportContainer: FunctionComponent<Props> = ({
  revision: revisionAsync,
  project: projectAsync,
  children,
}) => {
  const dispatch = useDispatch();

  const selectedDependencyInfoOptions = !_.isEmpty(projectAsync?.data?.bom_column_settings)
    ? (projectAsync?.data?.bom_column_settings as DependencyInfoOption[])
    : DefaultDependencyInfoOptions;
  const [dependencyInfoOptions, setDependencyInfoOptions] = useState(selectedDependencyInfoOptions);
  const reportCustomText = projectAsync?.data?.reportCustomText || '';
  const revision = revisionAsync?.data?.locator || '';

  useEffect(() => {
    dispatch(ReportGenerationStore.actions.setProjectContext({ revision }));
    dispatch(ReportGenerationStore.actions.setCustomHeaderText(reportCustomText));
    dispatch(ReportGenerationStore.actions.setDependencyInfoOptions(selectedDependencyInfoOptions));
  }, [dispatch, revision, reportCustomText, selectedDependencyInfoOptions]);

  return (
    <Provider value={{ dependencyInfoOptions, setDependencyInfoOptions }}>
      <div>{children}</div>
    </Provider>
  );
};

export default ProjectReportContainer;
